<div class="flex column-gap-2 col-12 card justify-content-start align-items-center">
  <input
    style="width:30%"
    pInputText
    placeholder="{{'Search_Lab' | translate}}"
    [(ngModel)]="filterName"
    [disabled]="reorgBsk"
    (keyup)="filter($event.target.value)"
  >
    @if (tagList != undefined) {
      <p-multiSelect
        class="w-20rem"
        styleClass="min-w-full max-w-full"
        [options]="tagList"
        [(ngModel)]="tagListSelect"
        placeholder="{{'Tag_Sel' | translate}}"
        optionLabel="name"
        display="chip"
        [disabled]="reorgBsk"
        (ngModelChange)="filterTag($event)"
        >
      </p-multiSelect>
    }
    @if (tagGroup.length > 0) {
      <p-multiSelect
        class="w-20rem"
        styleClass="min-w-full max-w-full"
        [options]="tagGroup"
        [(ngModel)]="tagListGroup"
        placeholder="{{'Superv_Sel' | translate}}"
        optionLabel="name"
        display="chip"
        [disabled]="reorgBsk"
        (ngModelChange)="filterGroup($event)"
        >
      </p-multiSelect>      
    }
    @if (!accesShortBsk) {
      <p-toggleButton
        onIcon="pi pi-eye-slash"
        offIcon="pi pi-eye"
        pTooltip="{{'Bsk_Hide' | translate}}"
        [(ngModel)]="internalPrefUsr.emptyBsk"
        (onChange)="onChangeCkEmptyBsk()">
      </p-toggleButton>
      <p-toggleButton
        onIcon="pi pi-plus-circle"
        offIcon="pi pi-minus-circle"
        pTooltip="{{'Pref_54' | translate}}"
        [(ngModel)]="internalPrefUsr.bskCompact"
        (onChange)="onCompactMode()">
      </p-toggleButton>
      <p-toggleButton
        offIcon="pi pi-th-large"
        onIcon="pi pi-table"
        pTooltip="{{'Reorder' | translate}}"
        [(ngModel)]="reorgBsk"
        (onChange)="onReorgBsk()">
      </p-toggleButton>
    }
    @if (reorgBsk) {
      <p-button
        icon="pi pi-save"
        pTooltip="{{'Save_Pos' | translate}}"
        styleClass="p-button-success p-button-rounded"
        (click)="saveBsk(true)">
      </p-button>
      <p-button
        icon="pi pi-replay"
        pTooltip="{{'Init_Pos' | translate}}"
        styleClass="p-button-rounded p-button-outlined"
        (click)="saveBsk(false)">
      </p-button>
    }
</div>
<div class="card flex flex-row container-height-with-top overflow-auto justify-content-evenly flex-wrap md:flex-row column-gap-1 gap-1">
  @if (basketAll.length === 0) {
      {{'Bsk_Empty_4' | translate}}
  }
  @for (bsk of basketAll; track bsk) {
    <!-- Accès bannette + ajout doc -->
    @if ((reorgBsk === false || accesBsk === true) && accesShortBsk === false && bsk.disabledBsk === false) {
      <basket
        mode='complete'
        [allowFullText]="allowFullText"
        [options]="bsk"
        [showGradient]="internalPrefUsr.gradBsk"
        [compactMode]="internalPrefUsr.bskCompact"
        (onSelect)="onSelectBasket($event, bsk)"
        (onFilter)="onFilterBasket($event, bsk)"
        (onSearch)="onFilterBasketSearch($event, bsk)"
        (onAddDoc)="onAddDocBasket($event, bsk)"
        >
      </basket>
    }
    <!--        Accès bannette navidation -->
    @if ((reorgBsk === false || accesBsk === true) && accesShortBsk === true && bsk.disabledBsk === false && bsk.Information.docCount
      != 0) {
      <basket
        mode='selectable'
        [allowFullText]="allowFullText"
        [options]="bsk"
        [showGradient]="internalPrefUsr.gradBsk"
        [compactMode]="internalPrefUsr.bskCompact"
        (onSelect)="onSelectBasket($event, bsk)"
        (onFilter)="onFilterBasket($event, bsk)"
        (onSearch)="onFilterBasketSearch($event, bsk)"
        (onAddDoc)="onAddDocBasket($event, bsk)"
        >
      </basket>
    }
    <!-- Visu bannette uniquement -->
    @if ((reorgBsk === false || accesBsk === true) && bsk.disabledBsk === true) {
      <basket
        mode='disabled'
        [options]="bsk"
        allowFullText="false"
        [showGradient]="internalPrefUsr.gradBsk"
        [compactMode]="internalPrefUsr.bskCompact"
        (onSelect)="onSelectBasket($event, bsk)"
        (onFilter)="onFilterBasket($event, bsk)"
        (onSearch)="onFilterBasketSearch($event, bsk)"
        (onAddDoc)="onAddDocBasket($event, bsk)"
        >
      </basket>
    }
    <!-- Réorganisation bannette -->
    @if (reorgBsk === true && accesBsk === false) {
      <div id="{{bsk.Information.Name}}" pDraggable="dd"
        pDroppable="dd" style="cursor: move;"
        (onDragStart)="drag($event)"
        (onDrop)="drop($event)"
        (dragover)="dragOver($event)"
        (onDragLeave)="dragLeave($event)"
        >
        <basket
          mode='disabled'
          allowFullText="false"
          [options]="bsk"
          [showGradient]="internalPrefUsr.gradBsk"
          [compactMode]="internalPrefUsr.bskCompact"
          (onSelect)="onSelectBasket($event, bsk)"
          (onFilter)="onFilterBasket($event, bsk)"
          (onSearch)="onFilterBasketSearch($event, bsk)"
          (onAddDoc)="onAddDocBasket($event, bsk)"
          >
        </basket>
      </div>
    }
  }
</div>
  @if (displaySearch === true) {
    <filterdocs
      [visible]="displaySearch"
      (onFilter)="onClickSearch($event)"
      (onClose)="closeSearch()"
      >
    </filterdocs>
  }
  @if (displayFilter === true) {
    <basketfilter
      [filterAuto]="basketService.currentFilterAuto"
      [data]="basketService.listRequest"
      [visible]="displayFilter"
      [editorService]="editorService"
      (onSelectFilter)="onClickFilter($event)"
      (onClose)="onCloseFilter()"
      >
    </basketfilter>
  }
  @if (displayNewDoc === true) {
    <basketnewdoc
      [bsk]="bsk"
      [baseRoot]="baseRoot"
      [storagePath]="storagePath"
      [usePreProcess]="usePreProcess"
      [preProcessName]="preProcessName"
      [parameterList]="parameterList"
      [priority]="priority"
      [visible]="displayNewDoc"
      (onClose)="onCloseNewDoc()"
      [visible]="displayNewDoc"
      (onClose)="onCloseNewDoc()"
      >
    </basketnewdoc>
  }
